module.exports = __webpack_public_path__ + "static/media/1008031.e0e7e84b.jpg";